import { render } from "./CreateSeries.vue?vue&type=template&id=45da598c&scoped=true"
import script from "./CreateSeries.vue?vue&type=script&lang=js"
export * from "./CreateSeries.vue?vue&type=script&lang=js"

import "./CreateSeries.vue?vue&type=style&index=0&id=45da598c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45da598c"]])

export default __exports__